import { render } from "./ITConsulting.vue?vue&type=template&id=c2c2aa28&scoped=true"
import script from "./ITConsulting.vue?vue&type=script&lang=js"
export * from "./ITConsulting.vue?vue&type=script&lang=js"

import "./ITConsulting.vue?vue&type=style&index=0&id=c2c2aa28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c2aa28"]])

export default __exports__